import { render } from "./Q2Both.vue?vue&type=template&id=01561bcf"
import script from "./Q2Both.vue?vue&type=script&lang=js"
export * from "./Q2Both.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__